// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3SMji";
var _3 = "icon-1peW5";
var _4 = "text-2KR5H";
var _5 = "InProcess-WXyj1";
var _6 = "AwaitingPayment-zQKjr";
var _7 = "NeedConfirm-2JuZt";
var _8 = "Finished-f0i7Y";
var _9 = "Rejected-3DFF2";
var _a = "Refused-Khd7m";
var _b = "TimelimitExpired-3e51z";
export { _1 as "__esModule", _2 as "root", _3 as "icon", _4 as "text", _5 as "InProcess", _6 as "AwaitingPayment", _7 as "NeedConfirm", _8 as "Finished", _9 as "Rejected", _a as "Refused", _b as "TimelimitExpired" }
export default { "__esModule": _1, "root": _2, "icon": _3, "text": _4, "InProcess": _5, "AwaitingPayment": _6, "NeedConfirm": _7, "Finished": _8, "Rejected": _9, "Refused": _a, "TimelimitExpired": _b }
